import { Box } from '@mui/material';
import Loader from 'Components/Forms/Loader';
import SearchToolbar from 'Components/Forms/SearchToolbar';
import DocumentSkeleton from 'FeatureModules/Document/Components/DocumentSkeleton';
import PaginatedRequestsTable from 'FeatureModules/Request/Components/Tables/PaginatedRequestsTable';
import { PARTNER_REQUEST_RECEIVED_ROWS_PER_PAGE } from 'utils/pagination.utils';
import usePartnerRequests from 'FeatureModules/Request/hooks/useRequests';
import React, { FC, Fragment } from 'react';
import ActionContainer from 'Components/ActionContainer';
import EmptySearchResults from 'Components/EmptySearchResults';
import ErrorState from 'Components/ErrorState';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';
import ScrollableTableContainer from 'Components/ScrollableTableContainer';

const RequestedDocuments: FC = () => {
  const { filteredRequests, loading, error, searchTerm, setSearchTerm, handleActionClick } =
    usePartnerRequests();

  if (error) {
    return <ErrorState />;
  }
  if (loading) {
    return <Loader />;
  }

  if (!filteredRequests.length && !searchTerm) {
    return (
      <PageContainer>
        <PageTitle title="Requests" />
        <Box mt={4}>
          <EmptySearchResults skeletonComponent={<DocumentSkeleton />} />
        </Box>
      </PageContainer>
    );
  }
  return (
    <PageContainer>
      <PageTitle title="Requests" />
      <Box position="relative">
        <ActionContainer>
          <SearchToolbar
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            data-testid="document-search-input"
            placeholder="Search request"
            className="search-input"
          />
        </ActionContainer>

        <ScrollableTableContainer>
          <PaginatedRequestsTable
            rowsPerPage={PARTNER_REQUEST_RECEIVED_ROWS_PER_PAGE}
            requests={filteredRequests}
            onActionClick={handleActionClick}
          />
        </ScrollableTableContainer>
      </Box>

      {searchTerm?.length && !filteredRequests.length ? (
        <EmptySearchResults
          message="No search results found"
          skeletonComponent={<DocumentSkeleton title={searchTerm} />}
        />
      ) : (
        <Fragment />
      )}
    </PageContainer>
  );
};

export default RequestedDocuments;
